import React from "react";
import { Card, Col, Button, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const MedicalProblemHeader = () => {
  const { state } = useLocation();

  return (
    <Card>
      <Card.Body>
        <Row className="flex-between-center">
          <Col md>
            <h5 className="mb-2 mb-md-0">
              Medical Problems{" "}
              {state.patientName ? ` (${state.patientName})` : null}
            </h5>
          </Col>
          {/* <Col xs="auto">
            <Button
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              type="button"
            >
              Discard
            </Button>
            <Button variant="primary" type="submit">
              Add User
            </Button>
          </Col> */}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default MedicalProblemHeader;
